const GeneratedContentTypeValues = [
  'generatingContent',
  'table',
  'chart',
  'highConfidence',
  'lowConfidence',
  'SQLError',
] as const;

// Create the enum from the values
export const GeneratedContentTypeEnum = {
  GENERATING_CONTENT: GeneratedContentTypeValues[0],
  TABLE: GeneratedContentTypeValues[1],
  CHART: GeneratedContentTypeValues[2],
  HIGH_CONFIDENCE: GeneratedContentTypeValues[3],
  LOW_CONFIDENCE: GeneratedContentTypeValues[4],
  SQL_ERROR: GeneratedContentTypeValues[5],
} as const;

// Create the type from the array values
export type GeneratedContentType = (typeof GeneratedContentTypeValues)[number];

export const TOGGLE_VALUES = {
  VISUALIZATION: 1,
  SQL: 2,
} as const; // `as const` ensures the object is treated as readonly and exact

export type ToggleSelectionType =
  (typeof TOGGLE_VALUES)[keyof typeof TOGGLE_VALUES];
